import { CompanyNewsTileType } from "@irati/types";
export var isRowEmpty = function (companyNewsTiles) {
    var hasContent = companyNewsTiles.filter(function (c) { return c.config.type !== CompanyNewsTileType.Empty; });
    return hasContent.length === 0;
};
export var doesRowContainEmpty = function (companyNewsTiles) {
    var emptyContent = companyNewsTiles.filter(function (c) { return c.config.type === CompanyNewsTileType.Empty; });
    return emptyContent.length > 0;
};
